import { fabric } from 'fabric';
import 'fabric-history';
import store from '../store';
import cloneDeep from 'clone-deep';
import pdfMake from 'pdfmake/build/pdfmake';
import Zoom from './Zoom';
import Fonts from './Fonts';
import Frame from './Frame';
import Project from './Project';

class Editor {

    canvas = null
    zoom = null
    project = null
    objectModifiedCallbacks = []

    callbacks = {
      'after:render': [],
      'object:modified': [],
      'object:moving': [],
      'mouse:dblclick': [],
      'selection:created': [],
      'selection:updated': [],
      'selection:cleared': [],
      'text:changed': [],
      'text:selection': [],
      'text:selection:changed': [],
      'text:editing:exited': [],
    }

    saveHistoryForCallbacks = [
      'object:modified',
      'text:selection:changed',
    ]

    extraProps = ['lockMovementX', 'lockMovementY', 'evented', 'selectable', 'excludeFromSVG', 'id', 'blocked', 'editable']

    get width() {
      return this.canvas.getWidth() / this.canvas.getZoom()
    }

    get height() {
      return this.canvas.getHeight() / this.canvas.getZoom()
    }

    async init(domElement, project) {

        this.project = new Project(project)

        return new Promise((resolve) => {
            try {
                this.initCanvas(domElement);
                this.zoom = new Zoom(this.canvas)
                this.preventUnload()

                resolve(true)

            } catch (error) {
                console.log(error)
            }
        })
    }

    refresh() {
        this.canvas.setBackgroundColor('#fff');
        this.canvas.setWidth(this.parseToPixel(this.project.totalWidth) * this.zoom.scale);
        this.canvas.setHeight(this.parseToPixel(this.project.totalHeight) * this.zoom.scale);

        this.canvas.clearHistory();

        // this.zoom.restoreZoom();

        // align and centering lines
        // initCenteringGuidelines(this.canvas)
        // initAligningGuidelines(this.canvas)
    }

    initCanvas(el) {

        this.canvas = new fabric.Canvas(el)
        this.canvas.setBackgroundColor('#fff', this.canvas.renderAll.bind(this.canvas));

        this.canvas.preserveObjectStacking = true;
        this.canvas.stopContextMenu = true;
        this.canvas.centeredScaling = true;
        this.canvas.selectionColor = 'rgba(254, 194, 196, .5)';
        this.canvas.selectionBorderColor = '#fec2c4';
        this.canvas.selection = false;

        this.canvas.setWidth(this.parseToPixel(this.project.totalWidth));
        this.canvas.setHeight(this.parseToPixel(this.project.totalHeight));

        // this.canvas.on('object:moving', (e) => {
        //     console.log('object:moving', e.target, e);
        //     if (e.target.id === 'personalizedField') {
        //         console.log('guest change', e.target.text);
        //         // store.dispatch('creator/setGuestPosition', { x: e.target.left, y: e.target.top })
        //     }
        // })

        // this.canvas.on('text:changed', function(e) {
        //     console.log('text:changed', e.target, e);

        //     if (e.target.id === 'personalizedField') {
        //         console.log('guest change', e.target.text);
        //         // store.dispatch('creator/setPreviewGuest', { content: e.target.text, display: e.target.text })
        //     }
        // });

        this.configureFabricJs()
        this.addListeners()

        // align and centering lines
        // initCenteringGuidelines(this.canvas);
        // initAligningGuidelines(this.canvas);
        console.log('init canvas done')
    }

    addListeners() {
        this.canvas.on('text:changed', (e) => {
            console.log('event text changed')
            this.callCallbacks('text:changed', e)
        })
        
        this.canvas.on('text:selection', () => {
            console.log('event text selection')
            this.callCallbacks('text:selection')
        })

        this.canvas.on('selection:created', () => {
            console.log('event selection created')
            this.callCallbacks('selection:created')
        })

        this.canvas.on('selection:updated', () => {
            console.log('event selection updated')
            this.callCallbacks('selection:updated')
        })

        this.canvas.on('selection:cleared', () => {
            console.log('event selection cleared')
            this.callCallbacks('selection:cleared')
        })

        this.canvas.on('object:modified', (e) => {
            console.log('callback object modified')
            this.callCallbacks('object:modified', e)
        })

        this.canvas.on('object:moving', (e) => {
            console.log('callback object moving')
            this.callCallbacks('object:moving', e)
        })

        this.canvas.on('mouse:dblclick', (e) => {
            console.log('callback mouse:dblclick')
            this.callCallbacks('mouse:dblclick', e)
        })

        this.canvas.on('text:selection:changed', () => {
            console.log('callback text selection changed')
            this.callCallbacks('text:selection:changed')
        })
        
        this.canvas.on('after:render', () => {
            console.log('callback after:render')
            this.callCallbacks('after:render')
        })
    }

    // initPreview() {

    // }

    async setPreview(guest = null, start = false) {
        console.log('set preview', guest)
        
        const personalized = this.project.personalizedVersion
        const content = JSON.parse(personalized.content)
        const field = content.objects.find((object) => object.id === 'personalizedField')

        if (!field) {
            return
        }

        if (guest === null && !start) {
            field.text = '[Pole personalizowane]'
            field.left = this.project.scene.guestCords.x
            field.top = this.project.scene.guestCords.y
            field.editable = false
            
            content.objects.map((object) => {
                object.opacity = 1

                if (!object.blocked) {
                    object.selectable = true
                    // object.evented = true
                }
            })
            
        } else {
            content.objects
                .filter((object) => object.id !== 'personalizedField')
                .map((object) => {
                    object.opacity = 0.3;
                    
                    if (object.selectable) {
                        object.selectable = false;
                        // object.evented = false;
                    } else {
                        object.blocked = true
                    }
                })
            
            // If active personalized field without guest list we want to block elements
            if (!start) {
              field.editable = true
              field.text = guest.content
              field.left = this.project.scene.guestCords.x + guest.x;
              field.top = this.project.scene.guestCords.y + guest.y;
            }
        }

        
        await this.loadContent(JSON.stringify(content))
        
        // if (guest === null) {
        //     // await this.loadContent(JSON.stringify(content))
        //     await this.loadVersion(0, this.project.activeScene)
        // } else {
        //     await this.loadContent(JSON.stringify(content))
        // }
    }

    callCallbacks(event, e) {
        console.log('call callbacks', event, this.callbacks[event])
        this.callbacks[event].forEach((callback) => callback(e))
        
        // Po zmianie zakladek/wylaczaniu podgladu zapisywanie nadpisuje content w store
        if (event !== 'after:render' && event !== 'selection:cleared') {
            // Save the canvas content - update store content
            this.saveContent(this.getContent())
        }

        if (this.saveHistoryForCallbacks.includes(event)) {
            // Save the change to history
            this.canvas._historySaveAction();
        }
    }

    saveContent(content) {
      // this.project.saveContent(JSON.stringify(content))
      store.dispatch('creator/setActiveInvitationContent', JSON.stringify(content))
    }

    getContent() {
      console.log('getContent.....')
        return this.canvas.toJSON(this.extraProps)
    }

    async getPdf() {

        pdfMake.fonts = {
          // load fonts used in project
          Roboto: {
              normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
              bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
              italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
              bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
          },
        };

        const fonts = this.project.getUsedFonts()

        fonts.forEach((font) => {

          const config = Fonts.getFontConfig(font)

          pdfMake.fonts[font] = {}

          pdfMake.fonts[font]['normal'] = `${window.location.origin}/fonts/${font}/Regular.ttf`
          
          if (config.bold) {
            pdfMake.fonts[font]['bold'] = `${window.location.origin}/fonts/${font}/Bold.ttf`
          }
          
          if (config.italic) {
            pdfMake.fonts[font]['italics'] = `${window.location.origin}/fonts/${font}/Italic.ttf`
          }
          
          if (config.boldItalic) {
            pdfMake.fonts[font]['bolditalics'] = `${window.location.origin}/fonts/${font}/BoldItalic.ttf`
          }
        })
        console.log('pdf fonts', pdfMake.fonts)
        let x = this.project.totalWidth;
        let y = this.project.totalHeight;

        x = (this.parseToPixel(x) / 3.77953) * 2.8434
        y = (this.parseToPixel(y) / 3.77953) * 2.8434

        var docDefinition = {
            pageMargins: 0,
            defaultStyle: {
                font: 'Roboto'
            },
            pageSize: {
                width: x,
                height: y
            },
            content: []
        };

        const staticVersion = [];
        const personalizedVersion = [];
        let personalizedIndex = 0;

        const versionsToGenerate = []

        this.project.versions.forEach((version, versionIndex) => {

          versionsToGenerate.push(new Promise((resolve) => {

            this.project.setVersion(versionIndex)

            const canvasEl = document.createElement('canvas');
            const canvas = new fabric.Canvas(canvasEl);

            canvas.setBackgroundColor('#fff');

            let x = this.parseToPixel(this.project.totalWidth)
            let y = this.parseToPixel(this.project.totalHeight)

            canvas.setWidth(x);
            canvas.setHeight(y);

            x = (x / 3.77953) * 2.8434;
            y = (y / 3.77953) * 2.8434;

            canvas.loadFromJSON(version.content, () => {

              canvas.setZoom(1);
              canvas.getObjects().forEach((object) => object.visible = !object.excludeFromSVG);

              const personalizedField  = canvas.getObjectById('personalizedField')

              if (personalizedField) {

                personalizedIndex = versionIndex

                this.project.scene.guests.forEach((guest) => {
                
                  personalizedField.text = guest.content
                  personalizedField.left = this.project.scene.guestCords.x + guest.x
                  personalizedField.top = this.project.scene.guestCords.y + guest.y

                  canvas.renderAll();

                  personalizedVersion.push({
                    svg: canvas.toSVG(),
                    width: x,
                    height: y
                  })

                })

              } else {
                staticVersion[versionIndex] = {
                  svg: canvas.toSVG(),
                  width: x,
                  height: y
                }
              }

              resolve()
            })
          }))
        });

        await Promise.all(versionsToGenerate)
        
        if (this.project.scene.exportAll) {

          // Get all versions in one pdf file

          personalizedVersion.forEach((guest) => {
            for (let versionIndex = 0; versionIndex < this.project.scene.versions.length; versionIndex++) {
              docDefinition.content.push(versionIndex == personalizedIndex ? guest : staticVersion[versionIndex])
            }
          })
  
          pdfMake.createPdf(docDefinition).download();

        } else {

          // Get every version in single pdf file
          
          staticVersion.forEach(async (version) => {

            docDefinition.content = Array(personalizedVersion.length).fill({
              svg: version,
              width: x,
              height: y,
            })

            console.log('for version')
            await new Promise((resolve) => {
              console.log('promise download')
              pdfMake.createPdf(docDefinition).download('moja nazwa', resolve);
            })
            
          })
          
          // setTimeout(() => {
            docDefinition.content = personalizedVersion
          
            console.log('download personalized')
            pdfMake.createPdf(docDefinition).download();
          // }, 2000)
        }

    }

    getPng() {

        this.zoom.resetZoom();
        
        let png = this.canvas.toDataURL({ format: 'png' });
        
        /* Change MIME type to trick the browser to downlaod the file instead of displaying it */
        png = png.replace(/^data:image\/[^;]*/, 'data:application/octet-stream');
        
        /* In addition to <a>'s "download" attribute, you can define HTTP-style headers */
        png = png.replace(/^data:application\/octet-stream/, 'data:application/octet-stream;headers=Content-Disposition%3A%20attachment%3B%20filename=Preview.png');
        
        this.zoom.restoreZoom();

        const link = document.querySelector('#png-save')

        link.href = png;
        link.download = 'preview.jpg';
        link.click();
    }

    addCallback(event, callback) {
        const events = (typeof event === 'object' ) ? event : [event]
        events.forEach((event) => this.callbacks[event].push(callback))
    }

    async loadVersion(version, scene) {

        // Set active scene and version
        console.log(scene, version)
        this.project.setScene(scene)
        this.project.setVersion(version)
        
       
        console.log('this.project.content', this.project.content)
        await this.loadContent(this.project.content)
    }

    async loadContent(content) {
        console.log('tutaj load')

        if (content.length === 0) {
            content = '{}'
        } 
        console.log('this.project', this.project)
        await Fonts.loadForProject(this.project)

        await new Promise((resolve) => {
            console.log('load content')
            this.canvas.loadFromJSON(content, () => {

                // Clear character cache to ensure bounding boxes for fonts are correct
                fabric.util.clearFabricFontCache();

                // Refresh canvas before frame draws for poper canvas size
                this.refresh()

                // Draw frames
                new Frame(this.project.version.margin, this.project.version.safePrint).drawFrames()

                // this.canvas.renderAll();
                // this.canvas.clearHistory();

                resolve(true)
            });
        })
    }

    getObjects() {
        if (!this.canvas) {
            return
        }

        return this.canvas.getObjects().reverse()
    }

    preventUnload() {
        window.addEventListener('beforeunload', (event) => {
            event.preventDefault();
            // Chrome requires returnValue to be set.
            event.returnValue = '';
        });
    }

    addText(text, properties) {
        const object = new fabric.Textbox(text, Object.assign({}, {
          fontFamily: 'Lato',
          fontSize: 20,
          lineHeight: 1.2,
          charSpacing: 0,
          fill: '#000',
          top: 0,
          left: 0,
          angle: 0,
          lockUniScaling: true,
          centerTransform: true,
          scaleX: 1,
          scaleY: 1,
          width: this.canvas.getWidth()
        }, properties))

        console.log('add text ', object)
      
        this.canvas.add(object);
        this.canvas.renderAll();
        this.canvas.viewportCenterObject(object)

        // Fire event for save canvas content
        this.canvas.fire('object:modified');
    }

    setText(text) {
        this.canvas.getActiveObject().set('text', text);
        this.canvas.renderAll();
    }

    addImage(img) {
        fabric.Image.fromURL(img, (img) => {
          img.angle = 0;
          img.scaleX = .5;
          img.scaleY = .5;
      
          this.canvas.insertAt(img, 200);
          this.canvas.renderAll();

          // Fire event for save canvas content
          this.canvas.fire('object:modified');
        })
    }

    setSlot(obj) {

      obj.clipPath = new fabric.Rect({
        left: obj.left, 
        top: obj.top,
        width: obj.width, 
        height: obj.height,
        scaleX: obj.scaleX,
        scaleY: obj.scaleY,
        selectable: false,
        absolutePositioned: true,
      })

      this.canvas.renderAll();
    }

    addSvg(svg, id = 'svg') {
      fabric.loadSVGFromURL(svg, (objects, options) => {

        options.id = id

        const obj = fabric.util.groupSVGElements(objects, options);

        obj.scaleToWidth(150);
        obj.scaleToHeight(150);

        this.canvas.add(obj);
        this.canvas.renderAll();

        // Fire event for save canvas content
        this.canvas.fire('object:modified');
      })        
    }

    setStyleForActiveObject(property, value, toggleValue = true, checkSelected = true) {

        const activeObject = this.canvas.getActiveObject()
        const selectedText = checkSelected && activeObject.getSelectedText();
        const isTextSelected = checkSelected && !!selectedText.length;
    
        if (isTextSelected) {
          const selectionStyles = activeObject.getSelectionStyles()
          const hasStyle = toggleValue && selectionStyles.length && selectionStyles.every((letter) => letter[property] == value);
          activeObject.setSelectionStyles({ [property]: hasStyle ? '' : value });
        } else {
            const hasStyle = toggleValue && activeObject[property] == value;
            const newVal = hasStyle ? '' : value;
    
            // If selection has own styles and we set style for whole
            // object then we have to override/set the same style for
            // every item in selection
            if (checkSelected) {
              Object.values(activeObject.styles).forEach((row) => {
                Object.values(row).map((item) => {
                  if (Object.prototype.hasOwnProperty.call(item, property)) {
                    item[property] = newVal;
                  }
                })
              })
            }
    
            activeObject.set(property, newVal);

            this.canvas.fire('object:modified');
        }

        this.canvas.renderAll();
    
        // Save the change to history
        this.canvas._historySaveAction();
    
        // save current state of canvas
        // canvasModifiedCallback();
    }

    parseToPixel(dimension) {
        switch(typeof dimension) {
            case 'object': {
                const newDimension = cloneDeep(dimension)
                Object.keys(newDimension).forEach((key) => newDimension[key] = fabric.util.parseUnit(`${newDimension[key]}mm`))
                return newDimension
            }
            default: 
                return parseFloat(fabric.util.parseUnit(`${dimension}mm`).toFixed(4))
        }
    }

    configureFabricJs() {

        // Set extra props for fabric history
        this.canvas.extraProps = this.extraProps

        // Turn off object caching for proper font styles update
        // fabric.Object.prototype.objectCaching = false;
        // fabric.Object.prototype.statefullCache = false;
        // fabric.Object.prototype.noScaleCache = false;

        fabric.IText.prototype.setControlsVisibility({
            tl:false, //top-left
            mt:false, // middle-top
            tr:false, //top-right
            ml:true, //middle-left
            mr:true, //middle-right
            bl:false, // bottom-left
            mb:false, //middle-bottom
            br:false //bottom-right
        })
          
        fabric.Object.prototype.borderColor = '#fec2c4';
        fabric.Object.prototype.cornerColor = '#fec2c4';
        fabric.Object.prototype.cornerSize = 10;

        /**
         * Convert images for export into base64
         */
        fabric.Image.prototype.getSvgSrc = function() {
            return this.toDataURLforSVG().replace("\ufeff", "");
        }
        
        fabric.Image.prototype.toDataURLforSVG = function(options) {
            var el = fabric.util.createCanvasElement();
                el.width  = this._element.naturalWidth || this._element.width;
                el.height = this._element.naturalHeight || this._element.height;
            el.getContext('2d').drawImage(this._element, 0, 0);
            var data = el.toDataURL(options);
            return data;
        }
        
        /**
         * Get element by unique id
         */
        fabric.Canvas.prototype.getObjectById = function(id) {
            var object = null,
                objects = this.getObjects();
        
            for (var i = 0, len = this.size(); i < len; i++) {
                if (objects[i].id && objects[i].id === id) {
                    object = objects[i];
                    break;
                }
            }
        
            return object;
        }

        // align and centering lines
        const initAligningGuidelines = () => {

            var ctx = this.canvas.getSelectionContext(),
                aligningLineOffset = 5,
                aligningLineMargin = 4,
                aligningLineWidth = 1,
                aligningLineColor = 'rgb(0,255,0)',
                viewportTransform,
                zoom = 1;
          
            const drawVerticalLine = (coords) => {
              drawLine(
                coords.x + 0.5,
                coords.y1 > coords.y2 ? coords.y2 : coords.y1,
                coords.x + 0.5,
                coords.y2 > coords.y1 ? coords.y2 : coords.y1);
            }
          
            const drawHorizontalLine = (coords) => {
              drawLine(
                coords.x1 > coords.x2 ? coords.x2 : coords.x1,
                coords.y + 0.5,
                coords.x2 > coords.x1 ? coords.x2 : coords.x1,
                coords.y + 0.5);
            }
          
            const drawLine = (x1, y1, x2, y2) => {
              ctx.save();
              ctx.lineWidth = aligningLineWidth;
              ctx.strokeStyle = aligningLineColor;
              ctx.beginPath();
              ctx.moveTo(((x1+viewportTransform[4])*zoom), ((y1+viewportTransform[5])*zoom));
              ctx.lineTo(((x2+viewportTransform[4])*zoom), ((y2+viewportTransform[5])*zoom));
              ctx.stroke();
              ctx.restore();
            }
          
            const isInRange = (value1, value2) => {
              value1 = Math.round(value1);
              value2 = Math.round(value2);
              for (var i = value1 - aligningLineMargin, len = value1 + aligningLineMargin; i <= len; i++) {
                if (i === value2) {
                  return true;
                }
              }
              return false;
            }
          
            var verticalLines = [],
                horizontalLines = [];
          
            this.canvas.on('mouse:down', () => {
              viewportTransform = this.canvas.viewportTransform;
              zoom = this.canvas.getZoom();
            });
          
            this.canvas.on('object:moving', (e) => {
          
              var activeObject = e.target,
                  canvasObjects = this.canvas.getObjects(),
                  activeObjectCenter = activeObject.getCenterPoint(),
                  activeObjectLeft = activeObjectCenter.x,
                  activeObjectTop = activeObjectCenter.y,
                  activeObjectBoundingRect = activeObject.getBoundingRect(),
                  activeObjectHeight = activeObjectBoundingRect.height / viewportTransform[3],
                  activeObjectWidth = activeObjectBoundingRect.width / viewportTransform[0],
                  horizontalInTheRange = false,
                  verticalInTheRange = false,
                  transform = this.canvas._currentTransform;
          
              if (!transform) return;
          
              // It should be trivial to DRY this up by encapsulating (repeating) creation of x1, x2, y1, and y2 into functions,
              // but we're not doing it here for perf. reasons -- as this a function that's invoked on every mouse move
          
              for (var i = canvasObjects.length; i--; ) {
          
                if (canvasObjects[i] === activeObject) continue;
          
                var objectCenter = canvasObjects[i].getCenterPoint(),
                    objectLeft = objectCenter.x,
                    objectTop = objectCenter.y,
                    objectBoundingRect = canvasObjects[i].getBoundingRect(),
                    objectHeight = objectBoundingRect.height / viewportTransform[3],
                    objectWidth = objectBoundingRect.width / viewportTransform[0];
          
                // snap by the horizontal center line
                if (isInRange(objectLeft, activeObjectLeft)) {
                  verticalInTheRange = true;
                  verticalLines.push({
                    x: objectLeft,
                    y1: (objectTop < activeObjectTop)
                      ? (objectTop - objectHeight / 2 - aligningLineOffset)
                      : (objectTop + objectHeight / 2 + aligningLineOffset),
                    y2: (activeObjectTop > objectTop)
                      ? (activeObjectTop + activeObjectHeight / 2 + aligningLineOffset)
                      : (activeObjectTop - activeObjectHeight / 2 - aligningLineOffset)
                  });
                  activeObject.setPositionByOrigin(new fabric.Point(objectLeft, activeObjectTop), 'center', 'center');
                }
          
                // snap by the left edge
                if (isInRange(objectLeft - objectWidth / 2, activeObjectLeft - activeObjectWidth / 2)) {
                  verticalInTheRange = true;
                  verticalLines.push({
                    x: objectLeft - objectWidth / 2,
                    y1: (objectTop < activeObjectTop)
                      ? (objectTop - objectHeight / 2 - aligningLineOffset)
                      : (objectTop + objectHeight / 2 + aligningLineOffset),
                    y2: (activeObjectTop > objectTop)
                      ? (activeObjectTop + activeObjectHeight / 2 + aligningLineOffset)
                      : (activeObjectTop - activeObjectHeight / 2 - aligningLineOffset)
                  });
                  activeObject.setPositionByOrigin(new fabric.Point(objectLeft - objectWidth / 2 + activeObjectWidth / 2, activeObjectTop), 'center', 'center');
                }
          
                // snap by the right edge
                if (isInRange(objectLeft + objectWidth / 2, activeObjectLeft + activeObjectWidth / 2)) {
                  verticalInTheRange = true;
                  verticalLines.push({
                    x: objectLeft + objectWidth / 2,
                    y1: (objectTop < activeObjectTop)
                      ? (objectTop - objectHeight / 2 - aligningLineOffset)
                      : (objectTop + objectHeight / 2 + aligningLineOffset),
                    y2: (activeObjectTop > objectTop)
                      ? (activeObjectTop + activeObjectHeight / 2 + aligningLineOffset)
                      : (activeObjectTop - activeObjectHeight / 2 - aligningLineOffset)
                  });
                  activeObject.setPositionByOrigin(new fabric.Point(objectLeft + objectWidth / 2 - activeObjectWidth / 2, activeObjectTop), 'center', 'center');
                }
          
                // snap by the vertical center line
                if (isInRange(objectTop, activeObjectTop)) {
                  horizontalInTheRange = true;
                  horizontalLines.push({
                    y: objectTop,
                    x1: (objectLeft < activeObjectLeft)
                      ? (objectLeft - objectWidth / 2 - aligningLineOffset)
                      : (objectLeft + objectWidth / 2 + aligningLineOffset),
                    x2: (activeObjectLeft > objectLeft)
                      ? (activeObjectLeft + activeObjectWidth / 2 + aligningLineOffset)
                      : (activeObjectLeft - activeObjectWidth / 2 - aligningLineOffset)
                  });
                  activeObject.setPositionByOrigin(new fabric.Point(activeObjectLeft, objectTop), 'center', 'center');
                }
          
                // snap by the top edge
                if (isInRange(objectTop - objectHeight / 2, activeObjectTop - activeObjectHeight / 2)) {
                  horizontalInTheRange = true;
                  horizontalLines.push({
                    y: objectTop - objectHeight / 2,
                    x1: (objectLeft < activeObjectLeft)
                      ? (objectLeft - objectWidth / 2 - aligningLineOffset)
                      : (objectLeft + objectWidth / 2 + aligningLineOffset),
                    x2: (activeObjectLeft > objectLeft)
                      ? (activeObjectLeft + activeObjectWidth / 2 + aligningLineOffset)
                      : (activeObjectLeft - activeObjectWidth / 2 - aligningLineOffset)
                  });
                  activeObject.setPositionByOrigin(new fabric.Point(activeObjectLeft, objectTop - objectHeight / 2 + activeObjectHeight / 2), 'center', 'center');
                }
          
                // snap by the bottom edge
                if (isInRange(objectTop + objectHeight / 2, activeObjectTop + activeObjectHeight / 2)) {
                  horizontalInTheRange = true;
                  horizontalLines.push({
                    y: objectTop + objectHeight / 2,
                    x1: (objectLeft < activeObjectLeft)
                      ? (objectLeft - objectWidth / 2 - aligningLineOffset)
                      : (objectLeft + objectWidth / 2 + aligningLineOffset),
                    x2: (activeObjectLeft > objectLeft)
                      ? (activeObjectLeft + activeObjectWidth / 2 + aligningLineOffset)
                      : (activeObjectLeft - activeObjectWidth / 2 - aligningLineOffset)
                  });
                  activeObject.setPositionByOrigin(new fabric.Point(activeObjectLeft, objectTop + objectHeight / 2 - activeObjectHeight / 2), 'center', 'center');
                }
              }
          
              if (!horizontalInTheRange) {
                horizontalLines.length = 0;
              }
          
              if (!verticalInTheRange) {
                verticalLines.length = 0;
              }
            });
          
            this.canvas.on('before:render', () => {
              this.canvas.clearContext(ctx);
            });
          
            this.canvas.on('after:render', () => {
              for (let i = verticalLines.length; i--; ) {
                drawVerticalLine(verticalLines[i]);
              }
              for (let i = horizontalLines.length; i--; ) {
                drawHorizontalLine(horizontalLines[i]);
              }
          
              verticalLines.length = horizontalLines.length = 0;
            });
          
            this.canvas.on('mouse:up', () => {
              verticalLines.length = horizontalLines.length = 0;
              this.canvas.renderAll();
            });
          }
          
          const initCenteringGuidelines = () => {
          
            var canvasWidth = this.canvas.getWidth(),
                canvasHeight = this.canvas.getHeight(),
                canvasWidthCenter = canvasWidth / 2,
                canvasHeightCenter = canvasHeight / 2,
                canvasWidthCenterMap = { },
                canvasHeightCenterMap = { },
                centerLineMargin = 4,
                centerLineColor = 'rgba(255,0,241,0.5)',
                centerLineWidth = 1,
                ctx = this.canvas.getSelectionContext(),
                viewportTransform;
          
            for (let i = canvasWidthCenter - centerLineMargin, len = canvasWidthCenter + centerLineMargin; i <= len; i++) {
              canvasWidthCenterMap[Math.round(i)] = true;
            }
            for (let i = canvasHeightCenter - centerLineMargin, len = canvasHeightCenter + centerLineMargin; i <= len; i++) {
              canvasHeightCenterMap[Math.round(i)] = true;
            }
          
            const showVerticalCenterLine = () => {
              showCenterLine(canvasWidthCenter + 0.5, 0, canvasWidthCenter + 0.5, canvasHeight);
            }
          
            const showHorizontalCenterLine = () => {
              showCenterLine(0, canvasHeightCenter + 0.5, canvasWidth, canvasHeightCenter + 0.5);
            }
          
            const showCenterLine = (x1, y1, x2, y2) => {
              ctx.save();
              ctx.strokeStyle = centerLineColor;
              ctx.lineWidth = centerLineWidth;
              ctx.beginPath();
              ctx.moveTo(x1 * viewportTransform[0], y1 * viewportTransform[3]);
              ctx.lineTo(x2 * viewportTransform[0], y2 * viewportTransform[3]);
              ctx.stroke();
              ctx.restore();
            }
          
            var isInVerticalCenter,
                isInHorizontalCenter;
          
            this.canvas.on('mouse:down', () => {
              viewportTransform = this.canvas.viewportTransform;
            });
          
            this.canvas.on('object:moving', (e) => {
              var object = e.target,
                  objectCenter = object.getCenterPoint(),
                  transform = this.canvas._currentTransform;
          
              if (!transform) return;
          
              isInVerticalCenter = Math.round(objectCenter.x) in canvasWidthCenterMap,
              isInHorizontalCenter = Math.round(objectCenter.y) in canvasHeightCenterMap;
          
              if (isInHorizontalCenter || isInVerticalCenter) {
                object.setPositionByOrigin(new fabric.Point((isInVerticalCenter ? canvasWidthCenter : objectCenter.x), (isInHorizontalCenter ? canvasHeightCenter : objectCenter.y)), 'center', 'center');
              }
            });
          
            this.canvas.on('before:render', () => {
              this.canvas.clearContext(ctx);
            });
          
            this.canvas.on('after:render', () => {
              if (isInVerticalCenter) {
                showVerticalCenterLine();
              }
              if (isInHorizontalCenter) {
                showHorizontalCenterLine();
              }
            });
          
            this.canvas.on('mouse:up', () => {
              // clear these values, to stop drawing guidelines once mouse is up
              isInVerticalCenter = isInHorizontalCenter = null;
              this.canvas.renderAll();
            });
          }

          initAligningGuidelines()
          initCenteringGuidelines()
    }


}

const editor = new Editor()

export default editor;